import React, { useState } from "react";

const cardData = [
  {
    title: "NATIVE APPLICATION",
    description: "A native application is a mobile app designed specifically for a particular operating system, such as Android or iOS. These apps are typically developed using system-specific programming languages and are made available through official platforms like the Google Play Store and the App Store.",
    image: require('../assets/Mobile.gif'),
    alt: "Mobile"
  },
  {
    title: "MOBILE WEB APPLICATION",
    description: "A mobile web application functions as a lightweight client. Once overshadowed by native apps, it has regained popularity with the advancement of HTML5 and CSS3 standards, enhancing user experience while providing greater functionality and richer features on mobile devices.",
    image: require('../assets/Laptop.gif'),
    alt: "Laptop"
  },
  {
    title: "HYBRID APPLICATION",
    description: "A hybrid application integrates HTML5, JavaScript, and CSS web technologies within a native app framework. This approach enables full access to mobile device features while allowing seamless distribution across multiple platforms.",
    image: require('../assets/Desktop.gif'),
    alt: "Desktop"
  }
];

const MobileAppSection = () => {
  const [expanded, setExpanded] = useState(Array(cardData.length).fill(false));

  const toggleReadMore = (index) => {
    setExpanded((prev) => {
      const newExpanded = [...prev];
      newExpanded[index] = !newExpanded[index];
      return newExpanded;
    });
  };
  return (

    <div className='pt-8 pb-16'>
      <div className="relative w-full bg-gray-100 py-10">
        <div className="text-center py-10 px-4">
          <h1 className="text-xl font-bold mb-3  font-primary">
            Delivering Stellar Services Of Development Of App
          </h1>
          <p className="text-base max-w-2xl text-gray-900 mx-auto font-primary">
            Looking to elevate your business with top-notch app development? Whether you believe it or not, operating without an app puts you at a disadvantage when it comes to client engagement. We design apps that deliver seamless experiences, ensuring your users keep coming back for more.
          </p>
        </div>
      </div>

      <div className=" bg-gray-200">
        <div className=' max-w-5xl mx-auto flex flex-col lg:flex-row justify-between items-center p-10  space-y-6 lg:space-y-0'>
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-xl text-gray-900 font-bold  font-primary mb-4">iPhone Apps</h2>
            <p className="text-gray-900 text-base font-primary">
              A vast community worldwide relies on iPhones, known for their elite status among devices. Our developers enhance this value by crafting exceptional apps. We’ll build a high-quality application for you, designed to compete on an international level and drive success for your organization.
            </p>
          </div>
          <div className="lg:w-1/4">
            <img
              src={require('../assets/ios.png')}
              alt="iPhone"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>

      <div className="flex flex-col lg:flex-row justify-between items-center p-10 space-y-6 lg:space-y-0 max-w-5xl mx-auto">
        <div className="lg:w-1/4">
          <img
            src={require('../assets/android_app.png')}
            alt="Android"
            className="w-full h-auto object-cover"
          />
        </div>
        <div className="lg:w-1/2 text-center lg:text-left ">
          <h2 className="text-xl text-gray-900 font-bold mb-4  font-primary">Android Apps</h2>
          <p className="text-gray-900 text-base font-primary">
            When it comes to developing profitable applications, we stand unrivaled, delivering the innovation your business needs. In no time, we can create cutting-edge apps designed to enhance the experience of the vast Android user base.
          </p>
        </div>
      </div>
      <div className=" bg-gray-200">
        <div className=' max-w-5xl mx-auto flex flex-col lg:flex-row justify-between items-center p-10  space-y-6 lg:space-y-0'>
          <div className="lg:w-1/2 text-center lg:text-left">
            <h2 className="text-xl text-gray-900 font-bold  font-primary mb-4">Hybrid Apps</h2>
            <p className="text-gray-900 text-base font-primary">
              A hybrid application integrates HTML5, JavaScript, and CSS web technologies within a native app framework. This approach enables full access to mobile device features while allowing seamless distribution across multiple platforms
            </p>
          </div>
          <div className="lg:w-1/4">
            <img
              src={require('../assets/HybridApp.png')}
              alt="iPhone"
              className="w-full h-auto object-cover"
            />
          </div>
        </div>
      </div>


      <div className="px-4 sm:px-16 lg:px-[170px] mt-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {cardData.map((card, index) => (
            <div key={index} className="bg-white shadow-lg rounded-tl-[0px] rounded-tr-[20px] rounded-bl-[0px] rounded-br-[20px] overflow-hidden py-6">
              <div className="flex justify-center items-center h-[150px]">
                <img
                  src={card.image}
                  alt={card.alt}
                  className="w-[120px] h-[120px] object-contain"
                />
              </div>
              <div className="p-6">
                <h3 className="text-xl font-bold text-center text-gray-900 font-primary">
                  {card.title}
                </h3>
                <p className="text-center text-gray-900 mt-2 text-base font-primary">
                  {expanded[index]
                    ? card.description
                    : `${card.description.substring(0, 100)}`}
                  {card.description.length > 100 && (
                    <>
                      {!expanded[index] && "... "}
                      <button
                        onClick={() => toggleReadMore(index)}
                        className="text-blue-500 font-semibold hover:underline focus:outline-none inline"
                      >
                        {expanded[index] ? "Read Less" : "Read More"}
                      </button>
                    </>
                  )}
                </p>
              </div>
            </div>
          ))}
        </div>

      </div>

     
    </div>
  );
};

export default MobileAppSection;
